import React from 'react';

//Estilos
import './DJCEEnEsperaDeFirma.css';

//Componentes
import TableContainer from '../table/TableContainer';

function DJCEEnEsperaDeFirma({ states, functions }) {
    const { tableData } = states;

    const { handleSubmit, onSubmitVistaDJCEs } = functions;

    return (
        <form
            className="DJCE_for_sign-container"
            onSubmit={handleSubmit(onSubmitVistaDJCEs)}
        >
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h3>No hay DJCEs para validar</h3>
            )}
            {tableData.data.length !== 0 && (
                <footer className="DJCE_for_sign-footer">
                    <button
                        className="btn btn-primary"
                        disabled={tableData.data.length === 0}
                    >
                        Visto
                    </button>
                </footer>
            )}
        </form>
    );
}

export default DJCEEnEsperaDeFirma;
